import React, { PureComponent } from 'react';

import Cookie from 'js-cookie';
import { connect } from 'react-redux';
import { RouteComponentProps, match, withRouter } from 'react-router';

import { SESSION_COOKIE_KEY } from 'src/account/services/session';
import { SELECTED_VENDOR_ID_COOKIE } from 'src/common/constants';
import { DesktopWidthView } from 'src/core/components/mediaQueries/DesktopWidthView';
import { MobileWidthView } from 'src/core/components/mediaQueries/MobileWidthView';
import history from 'src/core/services/history';
import {
  hasRouteTrackerVehiclesSelector,
  hasSnowPlowVehiclesEnabledSelector,
  hasStreetSweeperVehiclesEnabledSelector,
  loadVehicleTypesForVendor,
} from 'src/fleet/ducks/vehicleTypesForVendor';
import {
  billingFeatureStatusSelector,
  checkIfContainerManagementIsEnabled,
  checkIfSnowPlowIsEnabled,
  checkIfStreetSweepingIsEnabled,
  isCityAlertFeatureEnabled,
  isLocationAlertFeatureEnabled,
} from 'src/vendors/ducks/features';
import { AdminOnlyGuard, NonTechHaulerGuard, VendorWithGusIdGuard } from '../../account/components';
import { isRubiconNonTechHauler, vendorGusIdSelector } from '../../account/ducks';
import { DuckFunction } from '../../contracts/ducks';
import { Modal } from '../../core/components';
import { Button, ModalSection, Text } from '../../core/components/styled';
import translate from '../../core/services/translate';
import {
  AUTO_DISPATCH,
  NO,
  OPPORTUNITIES,
  PAYMENTS,
  SERVICE_CHANGE_REQUESTS,
  WORK_ORDERS,
  YES,
} from '../../opportunity/constants/status';
import { AppState } from '../../store';
import matchRoute from '../../utils/services/matchRoute';
import { SelectDefaultVendorModalToggle } from '../../vendors/components/modals';
import { SMART_CITY } from '../../vendors/constants';
import {
  flagLocationStatusSelector,
  geoFenceSelector,
  loadFeatures,
  wasteAuditStatusSelector,
} from '../../vendors/ducks';
import {
  currentUserIdSelector,
  currentVendorIdSelector,
  currentVendorTypeIdSelector,
} from '../../vendors/services/currentVendorSelector';
import { loadDispatchOpportunitiesCount } from '../ducks';
import { isOldDashboardNavigationLayout } from '../services/persistentDashboardNavigationLayout';
import { getTokenFromUrl } from '../utils/navigation';
import { MobileNavigationBar } from './MobileNavigationBar';
import { NavigationBarSettingsGear } from './NavigationBarSettingsGear';
import {
  BellNotification,
  MainNavigationBar,
  MainNavigationBarContent,
  MainNavigationIcon,
  MainNavigationItem,
  MainNavigationItemCount,
  MainNavigationLogo,
  NavigationBarContainer,
  NavigationMenu,
  NotificationsMenuItem,
  SubNavigationBar,
  SubNavigationItem,
  SubNavigationItemCount,
  SubNavigationItemWrapper,
} from './styled';

interface MatchParams {
  token?: string;
}

const isPaymentMainNavigationItemActive = (_match: match<MatchParams>, { pathname }: Location) =>
  matchRoute(pathname, '/payments');

// const isRubiconSelectMainNavigationItemActive = (_match: match<MatchParams>, { pathname }: Location) =>
//   matchRoute(pathname, '/rubicon-select');

const routeTrackerNavItem = 'routes.tracker';
const routePlannerNavItem = 'routes.planner.routePlanner';
const snowTrackerNavItem = 'routes.snowTracker';
const sweeperTrackerNavItem = 'routes.sweeperTracker';

interface Props extends RouteComponentProps<MatchParams> {
  currentUserId: string;
  currentVendorId: number;
  currentVendorTypeId: number;
  features: any;
  isNonTechHauler: boolean;
  isVendorWithGusId?: boolean;
  loadDispatchOpportunitiesCount: DuckFunction<typeof loadDispatchOpportunitiesCount>;
  loadFeatures: (vendorId: number) => Promise<any>;
  loadVehicleTypesForVendor: DuckFunction<typeof loadVehicleTypesForVendor>;
  notificationCounts: any;
  selectedVendorId?: string;
  selfUser: any;
  sessionCookie?: string;
}
interface State {
  isNotificationsMenuOpen: boolean;
  isSessionChanged: boolean;
  isVendorChanged: boolean;
}

let vendorOrSessionCookieInterval: NodeJS.Timeout;

class NavigationBar extends PureComponent<Props, State> {
  state = {
    isNotificationsMenuOpen: false,
    isSessionChanged: false,
    isVendorChanged: false,
  };

  static defaultProps = {
    features: {},
    notificationCounts: {},
  };

  get isLoggedIn() {
    return (this.props.selfUser && this.props.selfUser.vendor.vendorTypeId) || this.props.currentUserId;
  }

  componentDidMount() {
    const {
      currentUserId,
      currentVendorId,
      features,
      isVendorWithGusId,
      loadDispatchOpportunitiesCount,
      loadFeatures,
      loadVehicleTypesForVendor,
      match: {
        params: { token },
      },
      selectedVendorId,
      sessionCookie,
    } = this.props;

    if (!!currentUserId && !!currentVendorId && isVendorWithGusId) {
      loadDispatchOpportunitiesCount(currentUserId, currentVendorId, token);
    }
    if (!!currentVendorId && !features.features.length && !features.isLoading) {
      loadFeatures(currentVendorId);
      loadVehicleTypesForVendor(currentVendorId);
    }

    vendorOrSessionCookieInterval = setInterval(() => {
      if (Cookie.get(SELECTED_VENDOR_ID_COOKIE) !== selectedVendorId) {
        this.setState({ isVendorChanged: true });
      } else {
        this.setState({ isVendorChanged: false });
      }

      if (Cookie.get(SESSION_COOKIE_KEY) !== sessionCookie && !Cookie.get(SESSION_COOKIE_KEY)) {
        this.setState({ isSessionChanged: true, isVendorChanged: false });
      } else {
        this.setState({ isSessionChanged: false });
      }
    }, 1000);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeNotificationsMenu);
    clearInterval(vendorOrSessionCookieInterval);
  }

  getSubMenuIconCount = (key: string) => {
    const { notificationCounts } = this.props;
    if (key === OPPORTUNITIES) return notificationCounts.opportunities + notificationCounts.bidOpportunities;
    else if (key === SERVICE_CHANGE_REQUESTS) return notificationCounts.serviceChangeRequests;
    else if (key === WORK_ORDERS) return notificationCounts.workOrders;
  };

  getMainNavigationItem = (urlPath: string, isActive: any, iconName: string, titleTranslationKey: string) => (
    <React.Fragment>
      <MainNavigationItem to={urlPath} isActive={isActive}>
        <MainNavigationIcon icon={iconName} />
        {translate(titleTranslationKey)}
      </MainNavigationItem>
    </React.Fragment>
  );

  getSubNavigationItem = (url: string, titleTranslationKey: string, notificationCountKey?: boolean | string) => {
    const { pathname } = this.props.location;
    const dailyRoutesNavIsActive =
      matchRoute(pathname, '/route-tracker') && titleTranslationKey === routeTrackerNavItem;
    const routePlannerNavIsActive =
      matchRoute(pathname, '/route-planner') && titleTranslationKey === routePlannerNavItem;
    const snowTrackerNavIsActive = matchRoute(pathname, '/snow-tracker') && titleTranslationKey === snowTrackerNavItem;
    const sweeperTrackerNavIsActive =
      matchRoute(pathname, '/sweeper-tracker') && titleTranslationKey === sweeperTrackerNavItem;

    let notificationCount = 0;
    if (notificationCountKey) {
      notificationCount = this.getSubMenuIconCount(notificationCountKey as string);
    }
    const urlPath = `${url}?showActionRequired=${!!notificationCount ? YES : NO}`;

    return (
      <React.Fragment>
        <SubNavigationItemWrapper
          isActionRequired={notificationCountKey ? true : false}
          active={
            dailyRoutesNavIsActive || routePlannerNavIsActive || snowTrackerNavIsActive || sweeperTrackerNavIsActive
          }
        >
          <SubNavigationItem to={url}>{translate(titleTranslationKey)}</SubNavigationItem>
        </SubNavigationItemWrapper>
        {notificationCountKey && (
          <SubNavigationItem to={urlPath}>
            <SubNavigationItemCount isVisible={!!notificationCount}>
              {notificationCount > 99 ? '99+' : notificationCount}
            </SubNavigationItemCount>
          </SubNavigationItem>
        )}
      </React.Fragment>
    );
  };

  onDefaultVendorSelected = () => {
    clearInterval(vendorOrSessionCookieInterval);
  };

  getVendorPortalChanger = () => (
    <AdminOnlyGuard>
      <SelectDefaultVendorModalToggle onDefaultVendorSelected={this.onDefaultVendorSelected} />
    </AdminOnlyGuard>
  );

  getSettingsPanel = (signInNonTechHaulerUrl: (url: string) => string) => (
    <NavigationBarSettingsGear
      isLoggedIn={(this.props.selfUser && this.props.selfUser.vendor.vendorTypeId) || this.props.currentUserId}
      signInNonTechHaulerUrl={signInNonTechHaulerUrl('/account/login')}
    />
  );

  getNotificationSubNavigationUrl = (url: string, showActionRequired: string | number) => {
    const {
      location: { pathname },
    } = this.props;
    const autoDispatchToken = matchRoute(pathname, '/workorders')
      ? getTokenFromUrl(pathname, WORK_ORDERS.toLowerCase())
      : getTokenFromUrl(pathname, AUTO_DISPATCH);

    const opportunitiesToken = getTokenFromUrl(pathname, OPPORTUNITIES.toLowerCase());

    const showOpportunitiesForToken = matchRoute(pathname, 'opportunities/') && opportunitiesToken;

    const showOpenDispatchesForToken = matchRoute(pathname, 'workorders/') && autoDispatchToken;

    if (showOpportunitiesForToken) return url + opportunitiesToken + `?showActionRequired=${showActionRequired}`;
    else if (showOpenDispatchesForToken) return url + autoDispatchToken + `?showActionRequired=${showActionRequired}`;
    return url + `?showActionRequired=${showActionRequired}`;
  };

  getMainNavigationRubiconLogo = (path: string) => {
    const opportunitiesPageActiveUrl = '/opportunities/';

    const { notificationCounts } = this.props;
    const showActionRequired = notificationCounts.total ? YES : NO;
    const opportunitiesCount = notificationCounts.opportunities + notificationCounts.bidOpportunities;

    return (
      <React.Fragment>
        <MainNavigationLogo to={path} />
        {!!notificationCounts.total && (
          <BellNotification onClick={this.openNotificationsMenu}>
            <MainNavigationItemCount isVisible={notificationCounts.total} onClick={this.openNotificationsMenu}>
              {notificationCounts.total > 99 ? '99+' : notificationCounts.total}
            </MainNavigationItemCount>
            <NavigationMenu isOpen={this.state.isNotificationsMenuOpen} isNotifications={notificationCounts.total}>
              <div>
                {!!opportunitiesCount && (
                  <NotificationsMenuItem
                    to={this.getNotificationSubNavigationUrl(opportunitiesPageActiveUrl, showActionRequired)}
                    id="menu-application-button"
                  >
                    <SubNavigationItemCount isVisible={opportunitiesCount}>
                      {opportunitiesCount > 99 ? '99+' : opportunitiesCount}
                    </SubNavigationItemCount>

                    <Text block size="small" margin="xxSmall">
                      {translate('opportunity.opportunities.opportunities')}
                    </Text>
                  </NotificationsMenuItem>
                )}
                {!!notificationCounts.serviceChangeRequests && (
                  <NotificationsMenuItem
                    to={this.getNotificationSubNavigationUrl(
                      '/opportunities/service-change-requests/',
                      showActionRequired,
                    )}
                    id="menu-application-button"
                  >
                    <SubNavigationItemCount isVisible={notificationCounts.serviceChangeRequests}>
                      {notificationCounts.serviceChangeRequests > 99 ? '99+' : notificationCounts.serviceChangeRequests}
                    </SubNavigationItemCount>
                    <Text block size="small" margin="xxSmall">
                      {translate('opportunity.serviceChangeRequests')}
                    </Text>
                  </NotificationsMenuItem>
                )}
                {!!notificationCounts.workOrders && (
                  <NotificationsMenuItem
                    to={this.getNotificationSubNavigationUrl('/workorders/', showActionRequired)}
                    id="menu-application-button"
                  >
                    <SubNavigationItemCount isVisible={notificationCounts.workOrders}>
                      {notificationCounts.workOrders > 99 ? '99+' : notificationCounts.workOrders}
                    </SubNavigationItemCount>

                    <Text block size="small" margin="xxSmall no no no">
                      {translate('autoDispatch.workOrders')}
                    </Text>
                  </NotificationsMenuItem>
                )}
              </div>
            </NavigationMenu>
          </BellNotification>
        )}
      </React.Fragment>
    );
  };

  closeNotificationsMenu = () => {
    this.setState({ isNotificationsMenuOpen: false });
    document.removeEventListener('click', this.closeNotificationsMenu);
  };

  openNotificationsMenu = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    this.setState({ isNotificationsMenuOpen: !this.state.isNotificationsMenuOpen });
    document.addEventListener('click', this.closeNotificationsMenu);
  };

  render() {
    const {
      currentVendorTypeId,
      isNonTechHauler,
      location: { pathname },
    } = this.props;
    const { isSessionChanged, isVendorChanged } = this.state;

    const showDashboardSubNavigationBar =
      matchRoute(pathname, '/workorders') ||
      matchRoute(pathname, '/opportunities/') ||
      matchRoute(pathname, '/opportunities/hauler-deliveries') ||
      matchRoute(pathname, '/opportunities/service-change-requests') ||
      matchRoute(pathname, '/rubicon-services') ||
      matchRoute(pathname, '/invoices');

    const showHaulerProfileSubNavigationBar =
      matchRoute(pathname, '/hauler-profile/overview') ||
      matchRoute(pathname, '/hauler-profile/compliance') ||
      matchRoute(pathname, '/hauler-profile/equipments') ||
      matchRoute(pathname, '/hauler-profile/services') ||
      matchRoute(pathname, '/hauler-profile/contacts') ||
      matchRoute(pathname, '/hauler-profile/agreements');

    const autoDispatchToken = matchRoute(pathname, '/workorders')
      ? getTokenFromUrl(pathname, WORK_ORDERS.toLowerCase())
      : getTokenFromUrl(pathname, AUTO_DISPATCH);
    const opportunitiesToken = getTokenFromUrl(pathname, OPPORTUNITIES.toLowerCase());
    const paymentsToken = getTokenFromUrl(pathname, PAYMENTS);

    const showOpenDispatchesForToken =
      (matchRoute(pathname, 'opendispatches/') ||
        matchRoute(pathname, 'rubicondispatches/') ||
        matchRoute(pathname, 'workorders/') ||
        matchRoute(pathname, 'serviceconfirmation/')) &&
      autoDispatchToken;

    const showOpportunitiesForToken =
      (matchRoute(pathname, 'opportunities/') || matchRoute(pathname, 'invoices/')) && opportunitiesToken;

    const showPaymentsForToken =
      (matchRoute(pathname, 'recurring-service/') ||
        matchRoute(pathname, 'oncall-service/') ||
        matchRoute(pathname, 'processed-service/')) &&
      paymentsToken;

    const opportunitiesUrl = (urlPrefix: string) => {
      if (showOpportunitiesForToken) return urlPrefix + opportunitiesToken;
      else if (showOpenDispatchesForToken) return urlPrefix + autoDispatchToken;
      return urlPrefix;
    };
    const openDispatchesUrl = (urlPrefix: string) => {
      if (showOpenDispatchesForToken) return urlPrefix + autoDispatchToken;
      else if (showOpportunitiesForToken) return urlPrefix + opportunitiesToken;
      return urlPrefix;
    };

    const paymentsUrl = (urlPrefix: string) => (showPaymentsForToken ? urlPrefix + paymentsToken : urlPrefix);
    const signInNonTechHaulerUrl = (urlPrefix: string) => {
      if (showOpenDispatchesForToken) return `${urlPrefix}?autoDispatchToken=${autoDispatchToken}`;
      else if (showOpportunitiesForToken) return `${urlPrefix}?opportunitiesToken=${opportunitiesToken}`;
      return urlPrefix;
    };

    const displayInvoicePage = currentVendorTypeId !== SMART_CITY;

    const oldDashboardNavigationLayout = isOldDashboardNavigationLayout();

    const workordersPageActiveUrl = matchRoute(pathname, '/fleet/autodispatch/rubicondispatches')
      ? '/fleet/autodispatch/rubicondispatches/'
      : '/workorders/';

    const clearVendorOrSessionCookieInterval = (action: any) => {
      clearInterval(vendorOrSessionCookieInterval);
      this.setState({ isVendorChanged: false, isSessionChanged: false });

      setTimeout(() => {
        action();
      });
    };

    const refreshPage = () => {
      clearVendorOrSessionCookieInterval(window.location.reload());
    };

    const redirectToLogin = () => {
      clearVendorOrSessionCookieInterval(
        history.push({ pathname: '/account/logout', state: { from: history.location } }),
      );
    };

    const opportunitiesPageActiveUrl = '/opportunities/';

    return (
      <>
        <DesktopWidthView isNavigation>
          <NavigationBarContainer>
            {!showOpportunitiesForToken && !showOpenDispatchesForToken && !showPaymentsForToken && !isNonTechHauler && (
              <MainNavigationBar>
                <MainNavigationBarContent>
                  {this.getMainNavigationRubiconLogo('/workorders')}

                  {/* {this.getMainNavigationItem(
                    '/rubicon-select',
                    isRubiconSelectMainNavigationItemActive,
                    'rubiconSelect',
                    'tooltips.select',
                  )} */}

                  {this.getVendorPortalChanger()}
                  {this.getSettingsPanel(signInNonTechHaulerUrl)}
                </MainNavigationBarContent>
              </MainNavigationBar>
            )}

            {(showOpportunitiesForToken || showOpenDispatchesForToken || isNonTechHauler) && (
              <MainNavigationBar>
                <MainNavigationBarContent>
                  {this.getMainNavigationRubiconLogo('/workorders')}
                  {/* {this.getMainNavigationItem(
                    '/rubicon-select',
                    isRubiconSelectMainNavigationItemActive,
                    'rubiconSelect',
                    'tooltips.select',
                  )} */}
                  {this.getVendorPortalChanger()}
                  {this.getSettingsPanel(signInNonTechHaulerUrl)}
                </MainNavigationBarContent>
              </MainNavigationBar>
            )}

            {showPaymentsForToken && (
              <MainNavigationBar>
                <MainNavigationBarContent>
                  {this.getMainNavigationRubiconLogo('/payments/recurring-service/')}
                  {this.getMainNavigationItem(
                    paymentsUrl('/payments/recurring-service/'),
                    isPaymentMainNavigationItemActive,
                    'paymentCircle',
                    'payment.payments',
                  )}
                </MainNavigationBarContent>
              </MainNavigationBar>
            )}

            {showDashboardSubNavigationBar && !oldDashboardNavigationLayout && isNonTechHauler && (
              <SubNavigationBar>
                {this.getSubNavigationItem(
                  opportunitiesUrl(opportunitiesPageActiveUrl),
                  'opportunity.opportunities.opportunities',
                  OPPORTUNITIES,
                )}
                {this.getSubNavigationItem('/rubicon-services', 'customers.rubiconServices', 'Rubicon Services')}
                {this.getSubNavigationItem(
                  '/opportunities/service-change-requests/',
                  'opportunity.serviceChangeRequests',
                )}

                <NonTechHaulerGuard>
                  {this.getSubNavigationItem(
                    openDispatchesUrl(workordersPageActiveUrl),
                    'autoDispatch.workOrders',
                    WORK_ORDERS,
                  )}
                </NonTechHaulerGuard>
                {this.getSubNavigationItem('/invoices', 'invoice.invoices')}
              </SubNavigationBar>
            )}

            {showDashboardSubNavigationBar && !oldDashboardNavigationLayout && !isNonTechHauler && (
              <VendorWithGusIdGuard>
                <SubNavigationBar>
                  {this.getSubNavigationItem(
                    opportunitiesUrl(opportunitiesPageActiveUrl),
                    'opportunity.opportunities.opportunities',
                    OPPORTUNITIES,
                  )}
                  {this.getSubNavigationItem('/rubicon-services', 'customers.rubiconServices')}
                  {this.getSubNavigationItem(
                    '/opportunities/service-change-requests/',
                    'opportunity.serviceChangeRequests',
                  )}
                  {this.getSubNavigationItem(
                    openDispatchesUrl(workordersPageActiveUrl),
                    'autoDispatch.workOrders',
                    WORK_ORDERS,
                  )}
                  {displayInvoicePage && this.getSubNavigationItem('/invoices', 'invoice.invoices')}
                </SubNavigationBar>
              </VendorWithGusIdGuard>
            )}

            {showHaulerProfileSubNavigationBar && (
              <SubNavigationBar>
                {this.getSubNavigationItem('/hauler-profile/overview', 'haulerProfile.overview')}
                {this.getSubNavigationItem('/hauler-profile/compliance', 'haulerProfile.compliance')}
                {this.getSubNavigationItem('/hauler-profile/equipments', 'haulerProfile.equipments.title')}
                {this.getSubNavigationItem('/hauler-profile/services', 'haulerProfile.services')}
                {this.getSubNavigationItem('/hauler-profile/contacts', 'haulerProfile.contacts')}
                {this.getSubNavigationItem('/hauler-profile/agreements', 'haulerProfile.agreements')}
              </SubNavigationBar>
            )}
          </NavigationBarContainer>
        </DesktopWidthView>
        <MobileWidthView isNavigation>
          <MobileNavigationBar isLoggedIn={this.isLoggedIn} />
        </MobileWidthView>

        {isVendorChanged && (
          <Modal size="small">
            <ModalSection align="center">
              <Text block size="large">
                {translate('settings.vendorChangedMessage')}
              </Text>
              <Button color="primary" onClick={refreshPage} margin="medium no no no">
                {translate('settings.refreshPage')}
              </Button>
            </ModalSection>
          </Modal>
        )}

        {isSessionChanged && (
          <Modal size="small">
            <ModalSection align="center">
              <Text block size="large">
                {translate('settings.sessionChangedMessage')}
              </Text>
              <Button color="primary" onClick={redirectToLogin} margin="medium no no no">
                {translate('account.login')}
              </Button>
            </ModalSection>
          </Modal>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  currentUserId: currentUserIdSelector(state.account.login) as any,
  currentVendorId: (currentVendorIdSelector as any)(state.account.login, state.vendors.defaultVendor),
  currentVendorTypeId: (currentVendorTypeIdSelector as any)(state.account.login, state.vendors.defaultVendor),
  features: state.vendors.features,
  isContainerManagementEnabled: checkIfContainerManagementIsEnabled(state),
  isFlagLocationActive: flagLocationStatusSelector(state.vendors.features.features) as any as boolean,
  isGeoFenceActive: geoFenceSelector(state.vendors.features.features) as any as boolean,
  isSnowPlowFeatureEnabled: checkIfSnowPlowIsEnabled(state),
  isStreetSweepingFeatureEnabled: checkIfStreetSweepingIsEnabled(state),
  isNonTechHauler: isRubiconNonTechHauler(
    state.account.login,
    state.vendors.defaultVendor,
    state.account.createUserAccount,
  ),
  isVendorWithGusId: vendorGusIdSelector(state.account.login, state.vendors.defaultVendor),
  isWasteAuditActive: wasteAuditStatusSelector(state.vendors.features.features) as any as boolean,
  location: state.router.location,
  notificationCounts: state.common.dispatchOpportunitiesCount.dispatchOpportunitiesCounts as any[],
  selectedVendorId: Cookie.get(SELECTED_VENDOR_ID_COOKIE),
  sessionCookie: Cookie.get(SESSION_COOKIE_KEY),
  selfUser: state.account.createUserAccount.selfUser,
  hasRouteTrackerVehicles: hasRouteTrackerVehiclesSelector(state),
  hasSnowPlowVehiclesEnabled: hasSnowPlowVehiclesEnabledSelector(state),
  hasStreetSweeperVehiclesEnabled: hasStreetSweeperVehiclesEnabledSelector(state),
  isCityAlertEnabled: isCityAlertFeatureEnabled(state),
  isLocationAlertEnabled: isLocationAlertFeatureEnabled(state),
  isBillingFeatureActive: !!billingFeatureStatusSelector(state.vendors.features.features),
});

const mapDispatchToProps = {
  loadDispatchOpportunitiesCount,
  loadFeatures,
  loadVehicleTypesForVendor,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavigationBar));
